const FOOTER_GROUPS = [
  {
    title: '导航入口',
    links: [
      { label: '人物索引', href: '#index' },
      { label: '事件脉络', href: '#events' },
      { label: '合集归档', href: '#collections' },
      { label: '来源速查', href: '#archive' },
    ],
  },
  {
    title: '更新与订阅',
    links: [
      { label: '今日快讯', href: '#feed' },
      { label: '分类分区', href: '#categories' },
      { label: '归档索引', href: '#archive' },
      { label: '整期下载', href: '#download' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '整理说明', href: '#feed' },
      { label: '来源与去重', href: '#archive' },
      { label: '更新日志', href: '#feed' },
      { label: '联系与反馈', href: '#download' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full border-t-4 border-primary-500 bg-secondary-950 px-4 md:px-8 pt-12 md:pt-16 pb-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8">
        <div className="lg:col-span-5">
          <div className="flex items-baseline gap-3">
            <span className="font-heading text-3xl md:text-4xl font-black tracking-tight text-background-50">17.cn</span>
            <span className="text-xs font-label tracking-[0.3em] text-primary-300">黑料导航</span>
          </div>
          <p className="mt-5 max-w-md text-sm leading-7 text-background-100/70">
            17.cn黑料导航汇总多方来源，按人物与事件整理成合集。持续整理、按日期归档，从导航入口快速定位目标内容。
          </p>
          <p className="mt-5 text-xs font-label tracking-[0.2em] text-background-100/50">持续整理 · 每日更新</p>
        </div>

        <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-8">
          {FOOTER_GROUPS.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-label tracking-[0.2em] text-background-50">{group.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm font-label text-background-100/70 transition-colors hover:text-accent-300 cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-12 border-t border-background-50/15 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs font-label text-background-100/60">
          © 2026 17.cn · 内容为多方来源公开信息整理，仅供导航与检索参考
        </p>
        <p className="text-xs font-label text-background-100/50">本页为静态导航首页 · 不提供在线提交</p>
      </div>
    </footer>
  );
}